import { CSSProperties } from 'react';
import classNames from 'classnames';

/**
 * See https://fonts.google.com/icons?icon.style=Rounded to add more icons
 */
const ICONS = [
    'add',
    'arrow_back',
    'arrow_forward',
    'check',
    'content_copy',
    'content_paste',
    'delete',
    'lock',
    'drag_indicator',
    'edit',
    'expand_more',
    'calendar_clock',
    'event_busy',
    'warning',
    'zoom_in',
    'zoom_out',
    'close',
    'search',
    'save',
    'cancel',
    'keyboard_arrow_up',
    'keyboard_arrow_down',
    'chevron_left',
    'chevron_right',
    'keyboard_double_arrow_left',
    'keyboard_double_arrow_right',
    'star',
    'upload',
    'link_off',
    'person',
    'sports_esports',
    'palette',
    'build',
    'card_giftcard',
    'inventory_2',
    'open_in_new',
    'event',
    'event_available',
    'check_circle',
    'schedule',
    'calendar_month',
    'filter_list',
    'redeem',
    'attach_file',
    'download',
    'description',
    'chat',
] as const;

export const IconLoader = () => {
    return (
        <link
            rel="stylesheet"
            href={`https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&icon_names=${ICONS.toSorted().join(
                ',',
            )}`}
        />
    );
};

export interface IconProps {
    name: (typeof ICONS)[number];
    className?: string;
    style?: CSSProperties;
}
export const Icon = ({ name, className, style = {} }: IconProps) => {
    return (
        <span
            className={classNames('material-symbols-rounded', className)}
            style={{ fontSize: 'inherit', ...style }}
        >
            {name}
        </span>
    );
};
